import React from "react";
import { Skeleton } from "antd";
import { formatCurrency, formatWithCommas } from "../../../assets/helpers";
import "./PortfolioOverview.scss";

/**
 * Aggregate lead panel. Inverted on purpose — the portfolio total is the one
 * number on this page that outranks everything else, and the dark ground makes
 * the brand orange read as an accent rather than as another card.
 */
const PortfolioOverview = ({ totals, count, format, loading }) => {
  const cells = [
    {
      label: "Resolved",
      value: formatWithCommas(totals.resolved),
      tone: "green",
    },
    {
      label: "Unresolved",
      value: formatWithCommas(totals.unresolved),
      tone: "amber",
    },
    {
      label: "Portfolios",
      value: formatWithCommas(count),
      tone: "blue",
    },
  ];

  return (
    <section className="bdash-overview">
      <span className="bdash-overview__glow" aria-hidden="true" />

      <div className="bdash-overview__lead">
        <span className="bdash-overview__label">Total ODPOS</span>

        {loading ? (
          <Skeleton.Input active style={{ width: 220, height: 40 }} />
        ) : (
          <b className="bdash-overview__value">
            {formatCurrency(totals.odpos, format)}
          </b>
        )}

        <div className="bdash-overview__meter">
          <div className="bdash-overview__meter-head">
            <span>Resolution progress</span>
            <b>{loading ? "—" : `${totals.progress}%`}</b>
          </div>
          <div className="bdash-overview__track">
            <i style={{ width: `${loading ? 0 : totals.progress}%` }} />
          </div>
        </div>
      </div>

      <div className="bdash-overview__cells">
        {cells.map((cell) => (
          <div className={`bdash-overview__cell is-${cell.tone}`} key={cell.label}>
            <span>{cell.label}</span>
            <b>{loading ? "—" : cell.value}</b>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioOverview;
